<template>
  <div id="app">
    <RouteProgress />
    <!-- list component that will be cached -->
    <router-view v-slot="{ Component }">
      <keep-alive :include="cachedComponents">
        <component :is="Component" :key="route.name"/>
      </keep-alive>
    </router-view>
    <!-- global transient notifications (e.g. "copied to clipboard") -->
    <Toast />
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue"
import { authStore } from './store/modules/auth.store'
import { useRoute } from "vue-router"
import Toast from './components/ui-elements/Toast.vue'
import RouteProgress from './components/ui-elements/RouteProgress.vue'
import { messageCenterHub } from './services/message-center-hub'

const route = useRoute()

watch(() => authStore.isLoggedIn, isLoggedIn => {
  if (isLoggedIn) {
    messageCenterHub.start()
  } else {
    messageCenterHub.stop()
  }
}, { immediate: true })

const cachedComponents = computed(() => {
  const required = ["Rates", "Providers"]
  const optional = ["Reports", "Networks", "Compare"]
  if (authStore.isLoggedIn) {
    return [...required, ...optional]
  }
  return required
})
</script>
